import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { AppState } from 'src/app/app.state';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-marketing-effectiveness-sheet',
  templateUrl: './marketing-effectiveness-sheet.component.html',
  styleUrls: ['./marketing-effectiveness-sheet.component.scss'],
})
export class MarketingEffectivenessSheetComponent implements OnInit {
  clientMarketingDetailsSheetActive = false;
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort1: MatSort;
  activeClient: any = {};
  onDestroyNotifier$ = new Subject();
  isDataLoading = true;
  tableColumnList: string[] = ['time', 'emailStatus', 'noOfListings', 'noOfClickThrough'];
  investorUsersCount: any;
  clientDetails: any;
  marketingEmailCount: any;
  pageIndex: number;
  clientFetchParams = { limit: 10, offset: 0, orderType: 'asc' };
  pageSize: any;

  constructor(
    public clientDashboardState: ClientDashboardState,
    private clientDashboardService: ClientDashboardService,
    public authorizeService: AuthorizeService,
    public appState: AppState
  ) {}

  ngOnInit(): void {
    this.clientDashboardState.openMarketingEffectivenessSheet$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((status) => {
        this.clientMarketingDetailsSheetActive = status;
      });

    this.clientDashboardState.activeClientMarketingDetails$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((data: any) => {
        if (data) {
          this.clientDetails = data;
          this.fetchMarketingEmailDetails(data, this.clientFetchParams);
        }
      });
    this.clientDashboardState.marketingEmailDetails$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((count) => {
      this.marketingEmailCount = count;
    });
    this.clientDashboardState.activeClientMarketingEmailDetails$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((data: any) => {
        if (data && data.length) {
          this.investorUsersCount = data.length;
          this.dataSource = new MatTableDataSource(data);
          this.dataSource.sort = this.sort1;
        } else if (!data.length) {
          this.investorUsersCount = null;
        }
      });
  }

  closeMarketingEffectivenessSheet() {
    this.clientMarketingDetailsSheetActive = false;
    this.clientDashboardState.openClientMarketingDetailsSheetValue = false;
    this.dataSource = new MatTableDataSource([]);
  }

  openPropertyDetailsSheet(clientDetails) {
    this.clientDashboardState.activeClientEmailHistoryValue = clientDetails;
    this.clientDashboardState.openPropertyDetailsSheetValue = true;
  }

  fetchMarketingEmailDetails(data, fetchParams) {
    this.clientDetails = data;
    let params = {
      email: this.clientDetails.email,
      id: this.clientDetails.id,
      limit: fetchParams.limit,
      offset: fetchParams.offset,
    };
    this.clientDashboardService.fetchClientMarketingEmail(params).subscribe((res: any) => {
      this.isDataLoading = res.isLoading;
    });
  }

  onPageChange(event) {
    if (this.clientFetchParams.offset != event.pageSize * event.pageIndex) {
      this.clientFetchParams.limit = event.pageSize;
      this.clientFetchParams.offset = event.pageSize * event.pageIndex;
    } else {
      this.clientFetchParams.limit = event.pageSize;
      this.paginator.pageIndex = 0;
      this.clientFetchParams.offset = 0;
    }
    this.fetchMarketingEmailDetails(this.clientDetails, this.clientFetchParams);
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
